const Ls11Alimentacion = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-7">
                    <h1 className='titulo--lesson--color--1'>Alimentaci&oacute;n para <span className='titulo--lesson--color--2'>beb&eacute;s prematuros</span></h1>

                    <h1 className="text--subtitulo p-4">Parte I</h1>

                    <div className='container ps-4 pe-5'>
                        <p className='texto--parrafo'>La leche materna proporciona la mejor nutrici&oacute;n para su beb&eacute;. Adem&aacute;s de suministrar los nutrientes importantes que un beb&eacute; prematuro necesita para crecer, tambi&eacute;n protege contra las infecciones, estrecha el v&iacute;nculo entre madre e hijo y contiene elementos que favorecen el desarrollo cerebral. Algunos de los nutrientes y los agentes protectores en la leche materna no est&aacute;n disponibles en las f&oacute;rmulas para lactantes prematuros.</p>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls11Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <h1 className="text--subtitulo p-4">Parte II: Posiciones para amamantar</h1>

                    <div className="container">
                        <div className="row d-flex text-center align-items-center gap-4">
                            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex align-items-center justify-content-around gap-3">
                                <div className="col-sm-6 col-md-6">
                                    <div className="col-12">
                                        <img src="./img/Ls11Amamantar-1.png" className='' />
                                    </div>
                                    <div className="col-12">
                                        <p className="texto--parrafo"><span className="texto--span">Acunado cruzado</span></p>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-6">
                                    <div className="col-12">
                                        <img src="./img/Ls11Amamantar-2.png" className='' />
                                    </div>
                                    <div className="col-12">
                                        <p className="texto--parrafo"><span className="texto--span">Acunado</span></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 d-flex align-items-center justify-content-around gap-5">
                                <div className="col-sm-6 col-md-6">
                                    <div className="col-12">
                                        <img src="./img/Ls11Amamantar-3.png" className='' />
                                    </div>
                                    <div className="col-12">
                                        <p className="texto--parrafo"><span className="texto--span">Pelota de f&uacute;tbol</span></p>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-6">
                                    <div className="col-12">
                                        <img src="./img/Ls11Amamantar-4.png" className='pt-4' />
                                    </div>
                                    <div className="col-12">
                                        <p className="texto--parrafo"><span className="texto--span">Acostado</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container ps-4 pt-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/multimedia/breast-feeding/sls-20076017?s=2'>http://www.mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/multimedia/breast-feeding/sls-20076017?s=2</a></p>
                    </div>

                </div>

                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls11Baby.gif" className='justify-content-start style--image-baby-10' />
                </div>
            </div>

            <div className="row d-flex">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className="text--subtitulo p-4">Parte III</h1>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls11Reloj.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja--bold lh-1 ps-lg-3 ps-xl-5 m-1'>Los beb&eacute;s prematuros requieren ser alimentados muy frecuentemente: <span className="texto--burbuja--bold--dorado">cada 2-3 horas.</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Existe algunas medidas que <span className="texto--span-2">favorecen la producci&oacute;n de leche materna, como la misma succi&oacute;n del beb&eacute;</span> —que estimula la producci&oacute;n—, <span className="texto--span-2">una dieta balanceada y una ingesta frecuente de agua y l&iacute;quidos por parte de la madre.</span> <br /> <br /> Recuerde que la mayor&iacute;a de medicamentos se excretan por leche materna. Consulte a su m&eacute;dico/a sobre los medicamentos que est&aacute; tomando y evite el consumo de bebidas alcoh&oacute;licas y de cigarrillo.
                        </p>
                    </div>

                    <div className='container ps-4'>
                        <p className='texto--link'>Adaptado de: <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/in-depth/breastfeeding-nutrition/art-20046912'>http://www.mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/in-depth/breastfeeding-nutrition/art-20046912</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls11Alimentacion;